import { Component, Input, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { Platform, PopoverController } from "@ionic/angular";
import { OidcSecurityService } from "angular-auth-oidc-client";
import { OdataSachbearbeiterRequest } from "../../../api/models/odata-sachbearbeiter-request";
import { SachbearbeiterService } from "../../../api/services/sachbearbeiter.service";
import { UserRole } from "../../enums/global-enums";
import { isMobile, smallScreenHeight } from "../../global-functions/global-functions";
import { AuthService } from "../../services/auth.service";
import { BackService } from "../../services/back.service";
import { ThemeService } from "../../services/theme.service";

@Component({
  selector: "app-header",
  templateUrl: "./header.component.html",
  styleUrls: ["./header.component.scss"],
  standalone: false,
})
export class HeaderComponent implements OnInit {
  @Input()
  title: string;

  @Input()
  showBackButton: boolean = true;

  @Input()
  overrideBackButtonUrl: string;

  userData: any;
  uniquePopoverID = "";
  smallScreenHeight: boolean;
  smallScreenWidth: boolean;
  mailmanagerAktiv: boolean;

  popupPopoverOpen = false;
  popupPopoverEvent: any;
  popoverCopyRegex = /\d+\/\d+/;

  constructor(
    private oidcSecurityService: OidcSecurityService,
    private popoverController: PopoverController,
    private backService: BackService,
    private platform: Platform,
    private sachbearbeiterService: SachbearbeiterService,
    public router: Router,
    public authService: AuthService,
    public themeService: ThemeService,
  ) {
    this.uniquePopoverID = Math.random().toString(36).substring(7);
  }

  ngOnInit() {
    this.oidcSecurityService.userData$.subscribe((userData) => {
      this.userData = userData;
      const token = this.oidcSecurityService.getToken();
      const sb = userData?.sb;
      if (!token || !sb) {
        this.mailmanagerAktiv = false;
      } else {
        this.sachbearbeiterService
          .sachbearbeiterOdataRetrieveCreate({
            token: token,
            sb_kuerzel: sb,
          } as OdataSachbearbeiterRequest)
          .subscribe((sachbearbeiter) => {
            this.mailmanagerAktiv = sachbearbeiter?.MailManagerAktiv;
          });
      }
    });

    this.smallScreenHeight = smallScreenHeight(this.platform);
    this.smallScreenWidth = isMobile(this.platform);
  }

  toggleDarkTheme() {
    this.themeService.toggleDarkTheme();
  }

  getUsername() {
    return `${this.userData?.sb}`;
  }

  goBack() {
    this.router.navigate([this.overrideBackButtonUrl ?? this.backService.backPath], { replaceUrl: true });
  }

  logout() {
    this.oidcSecurityService.logoff();
  }

  dismissPopover() {
    this.popoverController.dismiss();
  }

  copyToClipboard(event: Event, text: string) {
    const match = text.match(this.popoverCopyRegex);
    if (!match) {
      return;
    }
    event.stopPropagation();

    const textToCopy = match[0];
    navigator.clipboard.writeText(textToCopy).then(() => {
      this.popupPopoverEvent = event;
      this.popupPopoverOpen = true;
      setTimeout(() => {
        this.popupPopoverOpen = false;
      }, 1500);
    });
  }

  highlightMatch(text: string) {
    return text.replace(this.popoverCopyRegex, (match) => `<span class="highlight-copy-text">${match}</span>`);
  }

  protected readonly UserRole = UserRole;
}
